import React from "react";
import IconLink from "./IconLink";
import { AccountIcon as AccountIconComponent } from "./icons";

export interface AccountIconProps {
  className?: string;
  "data-testid"?: string;
  onAccountClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const AccountIcon: React.FC<AccountIconProps> = ({
  className,
  "data-testid": dataTestId,
  onAccountClick,
}) => {
  return (
    <IconLink
      href="/account/myaccount/accountSummary.page"
      icon={<AccountIconComponent />}
      label="Account"
      onClick={onAccountClick}
      data-testid={dataTestId || "header-account-icon"}
      ariaLabel="My Account"
      className={`${className || ""} account`}
    />
  );
};

export default React.memo(AccountIcon);
